import produce from "immer";

import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { PolicyChangeRequestActions } from ".";
import { initialPolicyChangeReqState } from "./policyChangeRequest.types";
import { CLEAR_POLICY_CHANGE_REQ, FETCH_POLICY_CHANGE_REQ_LIST_FAILED, FETCH_POLICY_CHANGE_REQ_LIST_PROGRESS, FETCH_POLICY_CHANGE_REQ_LIST_SUCCESS, UPDATE_POLICY_CHANGE_REQ_LIST_ASSIGNED_TO } from "./policyChangeRequestActions";


export const policyChangeRequestReducer = (
  state: IStoreState["tasks"]["policyChangeRequest"] = initialPolicyChangeReqState,
  action: PolicyChangeRequestActions
) => {
  switch (action.type) {
    case FETCH_POLICY_CHANGE_REQ_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
      });
      return newState;
    }
    case FETCH_POLICY_CHANGE_REQ_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = list;
      });
      return newState;
    }
    case FETCH_POLICY_CHANGE_REQ_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
      });
      return newState;
    }
    case UPDATE_POLICY_CHANGE_REQ_LIST_ASSIGNED_TO: {
      const {assigned_to_id, assigned_to_name, change_request_code} = action.payload; 
       const newState = produce(state, (draftState) => {
        const item = draftState.list.find(x=>x.change_request_code === change_request_code);
        if(item){
          item.assigned_to_id = assigned_to_id;
          item.assigned_to_name = assigned_to_name;
        }
      });
      return newState;
    }

    case CLEAR_POLICY_CHANGE_REQ: {
      return initialPolicyChangeReqState;
    }

    default: {
      return state;
    }
  }
};
